import src from "IMAGE";
export default { src, width: 1232, height: 340, blurWidth: 0, blurHeight: 0};
